'use client';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { statusInfo } from './status';
export function StatusBadge({ value, label, icon }: { value?: string | boolean | null; label?: ReactNode; icon?: ReactNode; size?: 'small' | 'medium'; variant?: 'filled' | 'outlined' }) {
  const { i18n } = useTranslation(); const info = statusInfo(value, i18n.language);
  return <span className={`badge ${info.tone}`}>{icon}{label ?? info.label}</span>;
}
